import { customElement } from 'lit/decorators';
import { css, html, LitElement } from 'lit';
import { center, padding, row } from '../styles';
import CodeIcon from '@carbon/web-components/es/icons/code/16';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { annotation } from './common';


@customElement('pdq-tutorial-selection')
class PDQTutorialSelection extends LitElement {
  static styles = [
    row,
    center,
    padding,
    annotation,
    css`
    `];

  render() {

    const code1 = `
<pdq-data-request 
  id="users"
  url="https://jsonplaceholder.typicode.com/users"
  index="username" 
  data-type="json"
  strategy="useStale"  
  ></pdq-data-request>
<pdq-perspective-viewer
  id="users-viewer"
  height="300px" 
  table="users"
  selectable="true"
  ><template>{"columns": ["username"]}</template></pdq-perspective-viewer>
  
<pdq-perspective-viewer
  height="300px" 
  table="users-viewer-selected-table"
  ><template>{
    "columns": [
    "name",
    "username",
    "email",
    "phone"
  ]}</template></pdq-perspective-viewer>`;


    return html`
      <cds-tile>

        <h2>Selecting Data</h2>
        <p>The <cds-tag type="green">${CodeIcon({ slot: 'icon' })}pdq-perspective-viewer</cds-tag> not 
          only consumes a table, it also produces a view and a table, based on its config and selection</p>
        <p>The names of these dependent view & tables are composed of id of the pdq-perspective-viewer + -selected-table
        and -selected-view respectively. This allows simple master/detail views to be created quickly</p>
        
        <h3>Example</h3>
        <p>
        The show a list of usernames from the <cds-tag type="green">${CodeIcon({ slot: 'icon' })}pdq-data-request#users</cds-tag> 
        and then a separate  <cds-tag type="green">${CodeIcon({ slot: 'icon' })}pdq-perspective-viewer</cds-tag>
        that is connected to the "users-viewer-seledcted-table".
        </p>
        <p>Click on a username to see this in action.</p>
        <pdq-code-html code="${code1}"></pdq-code-html>
        ${unsafeHTML(code1)}
        <p>We shall revisit what we can do with dependent tables after looking into how we can render custom templates</p>
      </cds-tile>
    `;
  }
}